import Cookies from 'js-cookie'

export const destinationKey = 'VLIVE_DESTINATION'
const httpDestinationHeaderKey = 'X-Vlive-Destination'

// BlueGreenデプロイや個人開発環境トラフィック切替用のヘッダを動的付与する
export const getDestinationHeader = (): Record<string, string> => {
  const destinationHeaderValue = getDestinationHeaderValue()
  if (destinationHeaderValue && destinationHeaderValue !== 'undefined') {
    return { [httpDestinationHeaderKey]: destinationHeaderValue }
  }

  return {}
}

// Cookie経由のdestinationのみを参照する（preview環境ブラウザ直アクセス用のクエリ取得は廃止）
// WebViewからのロード時に使う（アプリでロード時にVliveDestination指定 -> proxy が Cookie に値を入れる）
export const getDestinationHeaderValue = (): string | null => {
  return Cookies.get(destinationKey) || null
}

// apiRoutes.ts の通信時 query param 付与にのみ利用する
// PreFlight(OPTIONS)リクエストのheaderは操作できないため、query paramで destination を伝える
export const getDestinationQueryParamIfNeeded = (
  originalUrl: string,
  destinationHeaderValue: string | null
) => {
  if (!destinationHeaderValue || destinationHeaderValue === 'stable') {
    return ''
  }

  const prefix = originalUrl.includes('?') ? '&' : '?'

  return `${prefix}destination=${destinationHeaderValue}`
}

